import './tailwind.css';
import 'react-toastify/dist/ReactToastify.css';

import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Routes from '~/resources/routes/index';
import store from '~/store';

const App: FunctionComponent = () => {
  return (
    <div className="text-theme-gray">
      <Provider store={store}>
        <ToastContainer />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </Provider>
    </div>
  );
};

export default App;
